export enum ReducerActionType {
  Update = "UPDATE",
  Reset = "RESET", // Reset to initial state
  Search = "SEARCH",
}
